import React from "react"

function LinkedIn(props) {
  return (
    <div {...props}>
      <svg
      className="w-full h-full"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="15" cy="15" r="15" fill="#F4F4F4" />
        <path
          d="M22 9.01333V20.9867C22 21.5467 21.5467 22 21 22H9C8.45333 22 8 21.5467 8 20.9867V9.01333C8 8.45333 8.44 8 9 8H21C21.5467 8 22 8.45333 22 9.01333ZM12.4 11.2C12.4 10.5333 11.8533 10 11.2 10C10.5467 10 10 10.5467 10 11.2C10 11.8533 10.5333 12.4 11.2 12.4C11.8667 12.4 12.4 11.8667 12.4 11.2ZM12.24 20V13.32H10.16V20H12.24ZM20.0133 16.3333C20.0133 14.5333 19.6267 13.1467 17.52 13.1467C16.5067 13.1467 15.8267 13.7067 15.56 14.2267H15.5333V13.32H13.5467V20H15.6267V16.6933C15.6267 15.8267 15.7867 14.9733 16.88 14.9733C17.9733 14.9733 17.96 15.9733 17.96 16.7467V20H20.04V16.3333H20.0133Z"
          fill="#A0A0A0"
        />
      </svg>
    </div>
  )
}

export default LinkedIn
